"use client";

import Image from "next/image";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Hero from "./Hero";
import Technologies from "./Technologies";
import TrustedBy from "./TrustedBy";
import Reviews from "./Reviews";

const sectionVariants = {
  hidden: { opacity: 0, y: 48 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
  },
};

export default function HomeClient() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"],
  });

  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);

  return (
    <main ref={containerRef} className="relative min-h-screen">
      {/* ── Fixed Parallax Background ── */}
      <div className="fixed inset-0 -z-10 bg-[var(--background)]">
        <motion.div
          className="absolute inset-0 h-[120vh] w-full"
          style={{ y: backgroundY }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-[var(--background)]/40 via-transparent to-[var(--background)]/90 mix-blend-multiply z-10" />
          <Image
            src="https://images.unsplash.com/photo-1705928418747-875e2e64a969?q=80&w=1974&auto=format&fit=crop"
            alt="Background"
            fill
            className="object-cover opacity-30 md:opacity-40 mix-blend-luminosity grayscale-[30%]"
          />
        </motion.div>
      </div>

      <motion.div variants={sectionVariants} initial="hidden" animate="show">
        <Hero />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
      >
        <Technologies />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
      >
        <TrustedBy />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
      >
        <Reviews />
      </motion.div>
    </main>
  );
}
